import React, { useEffect, useState } from 'react';
import { Card, Col, Descriptions, Row, Typography, Table } from 'antd';
import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftCircleOutlined, PrinterOutlined } from '@ant-design/icons'
import { paymentVoucherService } from '../../../../../services';
import Textword from '../../../../../utils/numberToWord';

const { Title } = Typography;

const PaymentPDF = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState([])
    const [data, setData] = useState([])

    const navigate = useNavigate();

    const handlePrint = () => {
        const printContents = document.getElementById('printableArea').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const handleBack = () => {
        navigate('/accounts/payment-vouchers');
    };
    const columns = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            align: "center",
        },
        {
            title: 'EXPENSE VOUCHER',
            dataIndex: 'expense_voucher',
            key: 'expense_voucher',
            align: "center",
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            align: "center",
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            align: "center",
        },
    ];

    const voucher = {
        id: '12345',
        date: '2023-10-01',
        amount: '150.00',
        description: 'Office Supplies',
        payee: 'ABC Stationery',
        paymentMode: 'Zelle',
        BankAcc: null,
        expenseSubaccount: 'Stationery',
        company: 'H LOGISTIC'
    };

    const amountInWords = "One Hundred Fifty Dollars Only";

    const initialize = async () => {
        const { success, data } = await paymentVoucherService.viewVoucher(id)
        if (success) {
            const tableData = [
                {
                    key: '1',
                    sno: '1',
                    expense_voucher: "990011",
                    description: data.special_note,
                    amount: data.amount,
                }
            ]
            setFormData(data)
            setData(tableData)
        }
    }

    useEffect(() => {
        initialize();
    }, [])

    return (
        <div style={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: 'auto', width: "auto", backgroundColor: 'transparent' }}>
            <Card id="printableArea" style={{ width: '100%', padding: 20 }}>
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <img src="/images/ctrade-logo.png" alt="Ctrade Logo" style={{ width: 100, marginBottom: 20 }} />
                    </div>
                    <Title level={2}>Payment Voucher</Title>
                </div>
                <Row gutter={20}>
                    <Col span={12}>
                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<strong>Vendor Name</strong>}>{formData?.vendor_name}</Descriptions.Item>
                            <Descriptions.Item label={<strong>Payment Mode</strong>}>{formData?.payment_mode_name}</Descriptions.Item>
                            <Descriptions.Item label={<strong>Bank Account</strong>}>{voucher.BankAcc}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                    <Col span={12}>
                        <Descriptions bordered column={1}>
                            <Descriptions.Item label={<strong>Payment Voucher No</strong>}>{id}</Descriptions.Item>
                            <Descriptions.Item label={<strong>Payment Actual Date</strong>}>{formData?.payment_date}</Descriptions.Item>
                            <Descriptions.Item label={<strong>Payment Company</strong>}>{formData?.company_name}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
                <Row style={{ marginTop: 30 }}>
                    <Col span={24}>
                        <Table columns={columns} dataSource={data} pagination={false} />
                    </Col>
                </Row>
                <Row style={{ marginTop: 20 }}>
                    <Col span={24} style={{ textAlign: 'center' }}>
                        <Typography.Text strong>Amount in Words: <Textword grandtotalAmount={formData?.amount} /> </Typography.Text>
                    </Col>
                </Row>
            </Card>
            <Row style={{ width: "100%", marginTop: 20 }}>
                <Col span={24} style={{ textAlign: "right" }}>
                    <Button type="primary" onClick={handleBack} style={{ marginRight: 10 }}><LeftCircleOutlined /> Back</Button>
                    <Button type="primary" onClick={handlePrint}><PrinterOutlined /> Print</Button>
                </Col>
            </Row>
        </div>
    );
};

export default PaymentPDF;
